import React from 'react';
import NavIconButton from './navIconButton';
import { ModuleNavigationPopover } from './moduleNavigationPopover';
import { useLocation } from 'react-router-dom';
import { getIsItemActive } from './helper';

const MODULE_DISPLAY_AMOUNT = 9;

const NavButtonGroup = ({ routes, currentId, isClient, isPwcReadOnly }) => {
  const location = useLocation();

  const routesToSlice = routes.map(getIsItemActive(location));
  const showProjectSetting = currentId && !isClient && !isPwcReadOnly;
  const hasExtraModule = routes.length > MODULE_DISPLAY_AMOUNT;

  const buttonsInSideBar = hasExtraModule
    ? routesToSlice.slice(0, MODULE_DISPLAY_AMOUNT)
    : [...routesToSlice];
  const buttonsInPopover = hasExtraModule
    ? routesToSlice.slice(MODULE_DISPLAY_AMOUNT)
    : null;

  if (showProjectSetting && buttonsInPopover) {
    const shouldSettingBtnActive =
      location.pathname.includes('projects/setting');
    const projectSettingBtn = {
      isActive: shouldSettingBtnActive,
      displayName: 'Go To Module Settings',
      iconId: 'setting',
      to: `/projects/setting?projectId=${currentId}&tab=modules`,
      isExternal: false,
    };
    // const arrayToInsertSettingBtn = hasExtraModule
    //   ? buttonsInPopover
    //   : buttonsInSideBar;

    buttonsInPopover.push(projectSettingBtn);
  }

  const popoverTop = {};
  buttonsInSideBar.map((i) => {
    if (i.value === 'analysis' || i.value === 'insight') {
      popoverTop[`--nav-item-top-${i.index}`] = `${i.subRoutes.length * 40}px`;
    }
    return i;
  });

  return (
    <ul className="nav-bar" style={popoverTop}>
      {buttonsInSideBar.map((i) => (
        <NavIconButton
          {...i}
          key={i.displayName}
          keyName={i.displayName}
          showPopover={i.value === 'analysis' || i.value === 'insight'}
        />
      ))}
      {hasExtraModule ? (
        <ModuleNavigationPopover
          routes={buttonsInPopover}
          // try to access `key` prop will return `undefined`
          keyName="module-navi"
        />
      ) : null}
    </ul>
  );
};

export default NavButtonGroup;
